import { withStyles } from "@material-ui/core";
import React from "react";
import Events from "../../../../../utilities/EventEmitter";
import Tooltip from "../../../../common/StyledToolTip";
import { KPI_NAME } from "../constants";
import { getDisplayServiceLevel, getServiceLevelValues } from "../../../shared/serviceLevelUtils";

const styles = (theme) => ({
  container: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    marginLeft: 24,
    "&:not(:last-child)": {
      marginRight: 24,
    },
    "&:last-child": {
      marginRight: 8,
    },
  },
  kpiSubGroupTag: {
    color: theme.iconColor,
    fontSize: theme.headerTextFontSize,
    fontWeight: 400,
    lineHeight: "19px",
    width: "max-content",
  },
  value: {
    color: theme.iconColor,
    fontWeight: 500,
    lineHeight: "22px",
    fontSize: theme.headerTextFontSize,
  },
  dividerStyle: {
    borderRight: `1px solid ${theme.AppBGColor}`,
    margin: "1 6 0 6",
  },
  kpiValuePositive: {
    color: theme.KPI.KPISingleValue,
  },
  kpiValueNegative: {
    color: theme.error,
  },
  link: {
    cursor: "pointer",
    textDecoration: "underline",
    "&:hover": {
      color: theme.HeaderSelectedText,
    },
  },
});

/*
  unary plus is the fastest and preferred way of converting something into a number, because it does not perform any other operations on the number.
  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Unary_plus#:~:text=Description-,Unary%20plus%20(%2B),if%20it%20isn%27t%20already.
*/
const getKPIColorClass = ({ classes, subGroupData, kpiValue, index }) => {
  const { kpiName, values } = subGroupData;
  const [actual, plan] = values;
  let value = +kpiValue;
  if (!value) {
    return "";
  }
  switch (kpiName) {
    case KPI_NAME.RETURN:
      return value > 0 ? classes.kpiValueNegative : classes.kpiValuePositive;
    case KPI_NAME.SPH:
    case KPI_NAME.BPH:
      if (index > 0) {
        return "";
      }
      return plan.value < actual.value
        ? classes.kpiValuePositive
        : classes.kpiValueNegative;
    case KPI_NAME.OT:
      return value > 0 ? classes.kpiValueNegative : "";
    default:
      return "";
  }
};

/* kpiName comes from the KPI API as a mapped service level, so it is matched against the
 mapped values rather than the display names. */
const shouldOpenDialogForKPI = (subGroupData, priorityShipmentList) => {
  return (
    [KPI_NAME.RETURN, KPI_NAME.APT].includes(subGroupData.kpiName) ||
    getServiceLevelValues(priorityShipmentList).includes(subGroupData.kpiName)
  );
};

const openShipmentModel = (kpiName) => {
  if (kpiName === KPI_NAME.RETURN) {
    Events.emit('OpenReturnShipments');
    return;
  }
  Events.emit('OpenPriorityShipments', kpiName);
};
const KPISubGroup = ({ classes, subGroupData, groupIndex, priorityShipmentList }) => {
  const lastValueIndex = subGroupData.values.length - 1;
  const subGroupValues = subGroupData.values.map((subGroup) => subGroup.value);
  const displayKpiName = getDisplayServiceLevel(
    subGroupData.kpiName,
    priorityShipmentList
  );

  return (
    <Tooltip title={subGroupData.description} key={`KPISubGroup-${groupIndex}`}>
      <div className={classes.container}>
        <div>
          {subGroupValues.map((kpiValue, index) => {
            const kpiClass = getKPIColorClass({
              classes,
              subGroupData,
              kpiValue,
              index,
            });
            return (
              <React.Fragment key={`value-${index}`}>
                <span className={`${classes.value} ${kpiClass}`}>
                  {kpiValue ?? 0}
                </span>
                {index !== lastValueIndex && (
                  <span className={classes.dividerStyle} />
                )}
              </React.Fragment>
            );
          })}
        </div>
        <div className={classes.kpiSubGroupTag}>
        {shouldOpenDialogForKPI(subGroupData, priorityShipmentList) ? (
            <div className={classes.link} onClick={() => openShipmentModel(subGroupData.kpiName)}>
              {displayKpiName}
            </div>
          ) : (
            displayKpiName
          )}
        </div>
      </div>
    </Tooltip>
  );
};
export default withStyles(styles)(KPISubGroup);
